export default "__VITE_ASSET__DkN$VTjZ__"